export default __webpack_public_path__ + "static/media/LeoHam.a44e2185.jpeg";